import React from 'react'
import { createComponent, createComponentWithProxy } from 'react-fela'

export const __artist = ({
	row,
	marginBottom = 'inherit',
	clickable,
	theme,
	isDesktop,
}) => ({
	textAlign: row ? 'left' : 'center',
	marginRight: row ? '0' : theme.spaces[16],
	marginBottom: `${marginBottom}`,
	display: 'flex',
	flexDirection: row ? 'row' : 'column',
	alignItems: 'center',
	cursor: clickable ? 'pointer' : 'default',
	paddingTop: row && theme.spaces['16'],
	maxWidth: isDesktop ? 'initial' : '96px',
})

export const __artistImg = ({ imageWidth = '96', theme, row }) => ({
	borderRadius: '50%',
	width: `${imageWidth}`,
	overflow: 'hidden',
	marginBottom: !row && theme.spaces['16'],
	'> div ': {
		'> img': {
			width: `${imageWidth}`,
			height: `${imageWidth}`,
			borderRadius: '50%',
		},
	},
})

export const __artistInfo = ({ pullRight = 'intial', isDesktop }) => ({
	paddingLeft: `${pullRight}`,
	width: isDesktop ? '60%' : 'auto',
	wordBreak: 'break-word',
})

export const ImageIconWrapper = createComponent(() => ({
	position: 'relative',
	display: 'inline-block',
}))

export const IconWrapper = createComponent(() => ({
	position: 'absolute',
	top: -2,
	right: -2,
	color: 'white',
	backgroundColor: '#3E6EEA',
	border: '2px solid white',
	borderRadius: '100%',
	height: '18px',
	width: '18px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
}))

export const ArtistIconWrapper = createComponentWithProxy(
	props => ({
		color: props.color ? props.color : 'inherit',
		fill: props.fill ? props.fill : 'currentColor',
		width: props.width ? props.width : 'inherit',
		height: props.height ? props.height : 'inherit',
		extend: [
			{
				condition: props.shadow,
				style: {
					filter: 'drop-shadow(2px 1px 4px #000)',
				},
			},
			{
				condition: props.rotate180,
				style: {
					transform: 'rotate(180deg)',
				},
			},
		],
	}),
	'svg'
)

export const ArtistIcon = ({ glyph, children, ...props }) => (
	<ArtistIconWrapper viewBox={`${glyph.viewBox}`} {...props}>
		<use
			// xlinkHref={__PROD__ ? wrapPublicPath(glyph.url) : `#${glyph.id}`}
			xlinkHref={`#${glyph.id}`}
		/>
	</ArtistIconWrapper>
)
